import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { WjNavModule } from '@grapecity/wijmo.angular2.nav';
import { WjInputModule } from '@grapecity/wijmo.angular2.input';
import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { AppCommonsModule } from '../../../commons/app-commons.module';

import { KYMW5400Component } from './kymw5400.component';
import { KYMW5800Module } from '../.././kymw58/kymw5800/kymw5800.module';
/**
 * ECカテゴリ関連マスタ画面モジュール設定クラス
 *
 * @export KYMW5400Module
 * @class KYMW5400Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
    WjGridModule,
    WjNavModule,
    WjInputModule,
    KYMW5800Module,
  ],
  declarations: [
    KYMW5400Component,
  ],
  providers: [
  ],
})
export class KYMW5400Module {

}
